export function FAQList({ items, categorized = false, categories }) {
  if (categorized && categories) {
    return (
      <div className="space-y-10">
        {categories.map((category) => (
          <div key={category.title}>
            <h3 className="text-xl font-semibold mb-4 text-secondary">{category.title}</h3>
            <div className="space-y-4">
              {category.items.map((item) => (
                <FAQItem key={item.q} question={item.q} answer={item.a} />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <FAQItem key={item.q} question={item.q} answer={item.a} />
      ))}
    </div>
  );
}

function FAQItem({ question, answer }) {
  return (
    <details className="group bg-white/5 rounded-2xl border border-purple-500/20 overflow-hidden">
      <summary className="flex justify-between items-center cursor-pointer p-6 font-semibold hover:bg-white/5 transition-colors list-none">
        <span>{question}</span>
        <i className="fa fa-chevron-down text-purple-400 group-open:rotate-180 transition-transform" />
      </summary>
      <p className="px-6 pb-6 text-purple-200 text-sm leading-relaxed">{answer}</p>
    </details>
  );
}
